import React from 'react'
import Header from '../headerone/Main'
import Bredcom from '../Bredcom/Main'
import { Link } from 'react-router-dom'
import NewMain from '../headerone/newMain'
function AcademicCertificate() {
  return (
    <>
      <NewMain />
      <Bredcom title="Home" subtitle="Certificate" />
      <br/><br/><br/><br/>


      <div class="container my-5">
      <div class="card shadow-sm border-0">
        <div class="card-body d-flex align-items-center justify-content-between">
          <div class="d-flex align-items-center">
            <i class="fas fa-file-pdf fa-2x text-danger me-3"></i>
            <div>
              <h5 class="card-title mb-1">Certificate</h5>
              <p class="card-text text-muted small mb-0">Download your certificate in PDF format</p>
            </div>
          </div>
          <a href="/assets/img/acamedica_certificate.pdf" class="btn btn-outline-danger" download>
            <i class="fas fa-download me-2"></i>Download
          </a>
        </div>
      </div>
    </div>


    </>
  )
}

export default AcademicCertificate